import React from 'react'
import {observer} from 'mobx-react'
import {useTranslation} from 'react-i18next'
import {Button, Col, Row, Typography} from 'antd'
import {GoogleManagerTagClassNames} from '@/constants'
import {DigitalReceiptsModal} from '..'

import {StartYourFreeTrialButtonProps} from './props'
import styles from './styles.scss'

export const StartYourFreeTrialButton = observer(({store}: StartYourFreeTrialButtonProps) => {
    const {t} = useTranslation()

    return (
        <>
            <div className={styles.root}>
                <Button
                    className={GoogleManagerTagClassNames.digitalReceipts.startYouFreePeriod}
                    onClick={store.openStartTrialModal}
                    size='large'
                    type='primary'
                >
                    <span className={GoogleManagerTagClassNames.digitalReceipts.startYouFreePeriod}>
                        {t('StartFreeTrial.cta')}
                    </span>
                </Button>
            </div>

            <DigitalReceiptsModal
                open={store.isStartTrialModalOpen}
                onClose={store.closeStartTrialModal}
                footer={
                    <Button
                        className={GoogleManagerTagClassNames.digitalReceipts.startYouFreePeriod}
                        type='primary'
                        size='large'
                        loading={store.isStartTrialLoading}
                        onClick={store.startFreeTrial}
                    >
                        <span
                            className={
                                GoogleManagerTagClassNames.digitalReceipts.startYouFreePeriod
                            }
                        >
                            {t('UpgradeZashPromo.confirm')}
                        </span>
                    </Button>
                }
            >
                <Row justify='center' align='middle' style={{textAlign: 'center'}}>
                    <Col xs={18}>
                        <Typography.Title level={3}>
                            {t('StartFreeTrial.modalTitle')}
                        </Typography.Title>
                    </Col>
                    <Col xs={18}>
                        <Typography.Paragraph>
                            {t('StartFreeTrial.modalDescription')}
                        </Typography.Paragraph>
                    </Col>
                </Row>
            </DigitalReceiptsModal>

            <DigitalReceiptsModal
                open={store.isStartTrialSuccessModalOpen}
                onClose={store.closeStartTrialSuccessModal}
                footer={
                    <Button type='primary' size='large' onClick={store.closeStartTrialSuccessModal}>
                        {t('UpgradeZashPromo.gotIt')}
                    </Button>
                }
            >
                <Row justify='center' align='middle' style={{textAlign: 'center'}}>
                    <Col xs={18}>
                        <Typography.Title level={3}>
                            {t('StartFreeTrial.successTitle')}
                        </Typography.Title>
                    </Col>
                    <Col xs={18}>
                        <Typography.Paragraph>
                            {t('StartFreeTrial.successDescription')}
                        </Typography.Paragraph>
                    </Col>
                </Row>
            </DigitalReceiptsModal>
        </>
    )
})
